import { z } from 'zod';
import { saveMeasureSchema } from './validation';
import { defaultMeasureDisplayFormatInput } from '../../../../../utils/builder/measures/measureDisplayFormat/utils';

export type ISaveMeasureState = z.infer<typeof saveMeasureSchema>;

export const defaultSaveMeasureFilterState: ISaveMeasureState = {
  strategy: 'create',
  name: '',
  description: null,
  comment: null,
  versionId: null,
  format: defaultMeasureDisplayFormatInput,
};
